module.exports = __webpack_public_path__ + "static/media/esign-kyc.e5a1789a.svg";